var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33195 22.0605C1.14862 22.267 1.1674 22.583 1.37391 22.7663L2.86953 24.0942C3.07603 24.2775 3.39206 24.2587 3.57539 24.0522L8.52637 18.4755C9.61671 18.8032 10.8003 19 12.0705 19C19.4955 19 24 12 24 12C24 12 22.1001 9.04759 18.7343 6.9776L22.8288 2.36564C23.0121 2.15913 22.9933 1.84311 22.7868 1.65977L21.2912 0.331956C21.0847 0.148622 20.7687 0.167404 20.5853 0.373907L15.9103 5.63978C14.7388 5.24355 13.4555 5 12.0705 5C4.4955 5 0 12 0 12C0 12 2.01914 15.144 5.63118 17.2179L1.33195 22.0605ZM10.1863 16.6059C10.7502 16.7964 11.3608 16.9 12 16.9C14.925 16.9 17.25 14.73 17.25 12C17.25 11.0739 16.9824 10.2122 16.5146 9.47777L14.9075 11.2879C14.9676 11.5093 15 11.7405 15 12C15 13.54 13.65 14.8 12 14.8C11.9312 14.8 11.863 14.7978 11.7953 14.7935L10.1863 16.6059ZM9.25799 13.1328L7.72289 14.8619C7.10921 14.0596 6.75 13.0731 6.75 12C6.75 9.27 9.075 7.1 12 7.1C12.7945 7.1 13.5447 7.2601 14.2161 7.54804L12.6882 9.26904C12.4734 9.22358 12.2485 9.1993 11.9992 9.1993L12 9.2C10.35 9.2 9 10.46 9 12C9 12.4026 9.09225 12.786 9.25799 13.1328Z",
    fill: "#96A1AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.40d7c25b264f65882e2897b5bf6932e2.svg";
export { ForwardRef as ReactComponent };